export default "__VITE_ASSET__DJcSPEgh__"